<template>
  <history-visit filter="active"></history-visit>
</template>

<script>
import historyVisit from "@/components/views/history/history-visits.view.vue";

export default {
  components: {
    historyVisit
  }
};
</script>
